import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import downloadIcon from '../../assets/images/download.png';
import './DownloadButton.css';

const DownloadButton = ({ data, headers, fileName }) => {
  const handleDownload = () => { // NOSONAR
    if (!data || data.length === 0) {
      return;
    }

    const exportData = data.map(item => {
      const row = {};
      headers.forEach(header => {
        if (header.displayIndication) {
          let value = item[header.columnName];
          
          if (header.formatter) {
            value = header.formatter(value, header, item);
          }
          
          if (header.dataType === 'datetime' || header.dataType === 'date') {
            if (value && typeof value === 'string') {
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = header.dataType === 'date' 
                  ? date.toLocaleDateString('en-GB')
                  : date.toLocaleString('en-GB');
              }
            }
          }
          
          if (header.status) {
            if (value === 'Y') value = 'Active';
            if (value === 'N') value = 'Inactive';
          }
          
          row[header.displayName] = value || '';
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');
    
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
    XLSX.writeFile(wb, `${fileName}_${timestamp}.xlsx`);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Download Excel</Tooltip>}
    >
      <div className="download-excel-btn" onClick={handleDownload}>
        <img
          className="download-excel-icon"
          src={downloadIcon}
          alt="Download Excel"
        />
      </div>
    </OverlayTrigger>
  );
};

export default DownloadButton;
